export default __webpack_public_path__ + "app/images/info-circle-bg-3.png";